export default __webpack_public_path__ + "static/media/angle-down.3eb42d42.svg";